import React from 'react';
import Header from '../shared/header';
import SideNav from '../shared/sideNav';
import 'font-awesome/css/font-awesome.min.css';
import '../assets/stylesheet/layout.scss';

//author-saksham
//function-common page layout for application
const Layout = ({ page: PageComponent }) => {
  return (
    <div>
      <Header />
      <div className="main-container">
        <SideNav />
        <section className="container-fluid">
          {PageComponent ? <PageComponent /> : <p>Page not found</p>}
        </section>
      </div>
    </div>
  );
};

export default Layout;
//end